import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const BackdropDriftAccelerationListItem = (props) => {
    const { acceleration, updateBackgroundSettings } = props;

    const onAccelerationChange = (value) => {
        updateBackgroundSettings({ drift: { acceleration: value } });
    };

    return (
        <SliderListItem
            title='Reactivity'
            displayMultiplier={1}
            value={acceleration}
            min={0}
            max={100}
            step={1}
            onValueChange={onAccelerationChange}
            toolTip='How much drift speeds up during loud audio.'
        />
    );
};

const mapStateToProps = (state) => {
    const { acceleration } = state.createPreview.present.videoSettings.background.drift;
    return { acceleration };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropDriftAccelerationListItem);
